import { OpcCatalogo, Opcion, Catalogo } from '../../models/catalogo.type'
import { transformarOpciones } from '../../utils/CatalogosUtil'
import { keysToCamel, keysToSnake } from '../../utils/ObjetosUtil'
import { baseApi } from './base.api'

export const catalogosApi = baseApi.injectEndpoints({
  //tagTypes: ["Post"],
  endpoints: (builder) => ({
    /**
     * Recupera opciones listas para componentes select.
     * El backend regresa estructura de catalogo y `transformarOpciones` la adapta a etiqueta/valor.
     */
    recuperarOpcCatalogo: builder.query<Opcion[], string>({
      query: (codigoCatalogo) => `${window._env_.API_CONTEXTO_CATALOGOS}/${codigoCatalogo}/options`,
      transformResponse: (response: OpcCatalogo[]) => {
        return keysToCamel(transformarOpciones(response))
      },
    }),

    recuperarCatalogos: builder.query<Catalogo[], string>({
      query: () => `${window._env_.API_CONTEXTO_CATALOGOS}/`,
    }),

    recuperarOpciones: builder.query<OpcCatalogo[], string>({
      query: (codigoCatalogo) => `${window._env_.API_CONTEXTO_CATALOGOS}/${codigoCatalogo}/options`,
    }),

    recuperarOpcionCatalogoPorId: builder.query<
      OpcCatalogo[],
      { codigoCatalogo: string; idOpcionCatalogo: string }
    >({
      query: (arg) => {
        return {
          url: `${window._env_.API_CONTEXTO_CATALOGOS}/${arg.codigoCatalogo}/options/${arg.idOpcionCatalogo}`,
          params: keysToCamel(arg),
        }
      },
    }),

    guardarOpcionCatalogo: builder.mutation({
      query: ({ catalog_code, ...catalogo }) => {
        return {
          url: `${window._env_.API_CONTEXTO_CATALOGOS}/${catalog_code}/options`,
          method: 'POST',
          body: keysToSnake(catalogo),
        }
      },
      //invalidatesTags: ["Post"],
    }),

    /**
     * Actualiza parcialmente una opcion de catalogo con merge-patch.
     */
    actualizarOpcionCatalogo: builder.mutation({
      query: ({ catalog_code, catalog_option_id, ...catalogo }) => {
        return {
          url: `${window._env_.API_CONTEXTO_CATALOGOS}/${catalog_code}/options/${catalog_option_id}`,
          method: 'PATCH',
          headers: {
            'content-type': 'application/merge-patch+json',
          },
          body: JSON.stringify(keysToSnake(catalogo)),
        }
      },
      //invalidatesTags: ["Post"],
    }),
  }),
})

export const {
  useRecuperarOpcCatalogoQuery,
  useRecuperarCatalogosQuery,
  useRecuperarOpcionesQuery,
  useLazyRecuperarOpcionesQuery,
  useRecuperarOpcionCatalogoPorIdQuery,
  useLazyRecuperarOpcionCatalogoPorIdQuery,
  useGuardarOpcionCatalogoMutation,
  useActualizarOpcionCatalogoMutation,
} = catalogosApi
